/** @module Camunda/TaskDefinitionProperties */
define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/heading/_base",
	"csi/locale",
	"csi/property/Widget",
	"Camunda",
	"./_TaskSetupMixin"
], function(declare, ExtendedPath, Key, csiHeading, locale, Widget, Camunda, _TaskSetupMixin) {

	return declare([Widget, _TaskSetupMixin], {
		/**
		 * @override
		 * Initialize view
		 */
		onViewCreate: function() {
			this._addTaskSetupExampleAction();
			this._addTaskSetupTitle();
			this.actionsNode = null;
		},

		/**
		 * @override
		 * Render action to show example view
		 */
		_postViewDeferred: function(ctx, dfds) {
			if (ctx.getNode().ViewStoreId) {
				const h = this.defView.findHeading("CustomView");
				if (h) {
					const nl = csiHeading.findHeadingNodes(this.domNode, h, this.urlRoot);
					this._renderTaskSetupExampleAction(ctx, nl[0], true);
				}
			}
		},

		/**
		 * @override
		 * Override default attribute keys for view
		 */
		_resolveAttributeKeys() {
			const taskDefinition = this.getViewNode();
			const extendedPath = ExtendedPath.create(this.defView.m_rcRoot);
			const attributeKey = (id) => new Key({id, extendedPath}).typedString;

			const attributeKeys = this.attributeKeys = [
				{
					name: locale.resource("TaskInformation"),
					keys: [
						attributeKey("Node Name"),
						attributeKey("Type"),
						attributeKey("TaskRole"),
						attributeKey("Info"),
					]
				},
			];

			if (taskDefinition && Camunda.taskDefinitionIsUserTask(taskDefinition)) {
				attributeKeys.push(
					{
						name: locale.resource("TaskActions"),
						keys: [
							attributeKey("ActionGroup"),
						]
					},
					{
						name: locale.resource("TaskView"),
						keys: [
							attributeKey("ViewPortal"),
							attributeKey("ViewStoreId"),
							attributeKey("CustomView"),
						]
					}
				);
			}

			this.inherited(arguments);
		}
	});
});